<template>
  <div id="modal-template">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <button class="modal-close-button" @click="$emit('close')">X</button>

          <div class="modal-body-body">
            <slot name="body">
              <AlcoholAndHealth v-if="wichModal === 'alcoholandhealth'" name="tecate00" />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlcoholAndHealth from '@/components/AlcoholAndHealth';
export default {
  name: "ModalAH",
  components: {
    AlcoholAndHealth
  },
  props: {
    wichModal: {
      type: String,
      default: "none"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/modalah.scss";
</style>